import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import { STATUS_PENDING } from '../../core/utils/constants';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PersonIcon from '@material-ui/icons/Person';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import BasicReadField from '../BasicReadField';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class SuggestionMiniDisplay extends React.Component {

  render() {

    const { data, existingValues, onShowSuggestion, id } = this.props;

    if (data.status && data.status[0] !== STATUS_PENDING) return null;

    const labelData = data.prefLabel || data.altLabel;
    const lang = Object.keys(labelData)[0];
    const invalid = existingValues && existingValues[lang] && existingValues[lang].some(ev => ev.toLowerCase() === labelData[lang].toLowerCase());

    return (
      <div>
        <BasicReadField
          lang={lang}
          invalid={invalid}
          helperText={invalid ? <span data-test="value-already-added">Value has now been added. Please reject.</span> : ""}
          icon={
            <React.Fragment>
              <Tooltip title="Added manually">
                  <PersonIcon />
              </Tooltip>
              {invalid ?
                <Tooltip title="View suggestion detail">
                  <span style={{ marginLeft: 6 }}>
                    <IconButton data-test="view-detail" size="small" onClick={() => onShowSuggestion(id)}>
                      <ThumbDownIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
                :
                <Tooltip title="View suggestion detail">
                  <span style={{ marginLeft: 6 }}>
                    <IconButton data-test="view-detail" size="small" onClick={() => onShowSuggestion(id)}>
                      <ThumbsUpDownIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              }
            </React.Fragment>
          }
          dataTest="suggested-label"
          fullWidth
          text={labelData[lang]} />
      </div>
    );
  }
}

SuggestionMiniDisplay.propTypes = {
  classes: PropTypes.object,
  existingValues: PropTypes.object,
  onShowSuggestion: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(SuggestionMiniDisplay, ["ALL"], null, {}, true));